import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';

import CardResultQuotation from './CardResultQuotation';
import ResultsQuotationNoResults from './ResultsQuotationNoResults';

const ResultsQuotationRenderList = ({ resultsToShow, quotationResults = [], onProductClick }) => {
  const [numbOfResultToShow, setNumbOfResultToShow] = useState(resultsToShow);

  useEffect(() => {
    setNumbOfResultToShow(resultsToShow);
  }, [quotationResults]);

  const onShowOtherClick = () => {
    setNumbOfResultToShow(quotationResults.length);
  };

  const onShowLessClick = () => {
    setNumbOfResultToShow(resultsToShow);
  };

  const quotationResultsToShow = quotationResults?.slice(0, numbOfResultToShow);

  if (quotationResults?.length < 3) {
    return (
      <Box sx={{ width: '100%' }}>
        <ResultsQuotationNoResults resultsNumber={quotationResults?.length} />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      {quotationResultsToShow?.map(q => (
        <CardResultQuotation
          key={q?.prodottoId}
          rata={q?.rata}
          duration={q?.durata}
          tan={q?.tan}
          taeg={q?.taeg}
          infoMutuo={q?.infoMutuo}
          bankName={q?.nomebanca}
          bankImage={q?.bankImage}
          istruttoria={q?.istruttoria}
          incendio={q?.incendio}
          perizia={q?.perizia}
          onCtaClick={() => onProductClick(q)}
        />
      ))}

      {quotationResults.length > quotationResultsToShow.length ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button
            onClick={onShowOtherClick}
            disableElevation
            sx={{
              color: '#0A92DE',
              fontFamily: 'var(--font-red-hat-display)',
              fontWeight: 'bold',
              fontSize: '13px',
              px: 4,
              textDecoration: 'none !important',
            }}>
            Mostra tutti
          </Button>
        </Box>
      ) : (
        quotationResults.length === quotationResultsToShow.length &&
        quotationResults.length > resultsToShow && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Button
              onClick={onShowLessClick}
              disableElevation
              sx={{
                color: '#0A92DE',
                fontFamily: 'var(--font-red-hat-display)',
                fontWeight: 'bold',
                fontSize: '13px',
                px: 4,
                textDecoration: 'none !important',
              }}>
              Comprimi
            </Button>
          </Box>
        )
      )}
    </Box>
  );
};

export default ResultsQuotationRenderList;
